import { css } from '@emotion/css';
import React from 'react';

export const EmptyCell: React.FC = () => {
  return (
    <li
      className={css`
        display: inline-block;
        width: 25%;
        padding: 8px 4px 12px;
        .cell {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 0;
        }
        .cell svg {
          width: 56px;
          height: 56px;
          margin: auto;
        }
        .space {
          width: 56px;
          height: 21px;
        }
        @media (min-width: 360px) {
          width: 20%;
        }
        @media (min-width: 400px) {
          .cell svg {
            width: 64px;
            height: 64px;
          }
          .space {
            width: 64px;
          }
        }
      `}
    >
      <div className="cell">
        <svg width="100%" height="100%" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="10" fill="#d1b8f9" />
        </svg>
        <div className="space" />
      </div>
    </li>
  );
};
